import z from 'zod';
import { artists } from '@/db/schema';
import { queryParamsSchema } from '../core/schemas';

const artistColumns = Object.keys(artists ?? {}) as [
  keyof typeof artists,
  ...(keyof typeof artists)[],
];

export const artistSchemas = {
  queryParams: queryParamsSchema.extend({
    orderBy: z
      .enum(
        artistColumns,
        'Campo inválido! Deve ser um dos seguintes: ' + artistColumns.join(', '),
      )
      .optional(),
    id: z.string().optional(),
    name: z.string().optional(),
    isActive: z.string().optional(),
    createdAt: z.coerce.date().optional(),
    createdAtFrom: z.coerce.date().optional(),
    createdAtTo: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    updatedAtFrom: z.coerce.date().optional(),
    updatedAtTo: z.coerce.date().optional(),
  }),
  create: z.object({
    name: z.string('Nome é obrigatório!').min(1, 'Campo obrigatório!'),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional().default(true),
  }),
  update: z.object({
    name: z.string('Nome é obrigatório!').optional(),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional(),
  }),
};

export type ArtistQueryParams = z.infer<typeof artistSchemas.queryParams>;
export type CreateArtistSchema = z.input<typeof artistSchemas.create>;
export type UpdateArtistSchema = z.infer<typeof artistSchemas.update>;
